import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useTranslationHook from "../../../../hooks/useTranslationHook";
import { updateBuyerRegistrationField } from "../../../../../redux/slice/buyerSlice";
import BidderRegistrationAgreementModal from "../modals/BidderRegistrationAgreementModal";
import { BUYER_REGISTRATION_STEPS, ID_TYPE } from "./constant";
import FileUploadItem from "../../../../seller/property/FileUploadItem";

const DetailsReview = () => {
    const dispatch = useDispatch();
    const { t } = useTranslationHook();
    const lang = useSelector((state) => state.translation.lang);
    const { isBidderRegistrationModalOpen } = useSelector(
        (state) => state.buyer.buyerRegistration
    );
    const { stepOneData, stepTwoData, registrationType } = useSelector(
        (state) => state.buyer.buyerRegistration.principal
    );

    const { principalIdDoc, powerOfAttorneyDoc } = stepTwoData;

    const setBuyerField = useCallback((field, value) => {
        dispatch(updateBuyerRegistrationField({ field, value }));
    }, []);
    return (
        <div>
            <div className="step-3">
                <section className="bidder-progress mb-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <h5>
                                    <span>3/3</span>
                                    {t("Review")}
                                </h5>
                                <ul>
                                    <li className="step active"></li>
                                    <li className="step active"></li>
                                    <li className="step "></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bidder-form">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-10 col-sm-12">
                                <div className="register-for-someone">
                                    <div
                                        className="prop-accordian accordion accordion-flush"
                                        id="accordionFlushExample"
                                    >
                                        <AccordionItem
                                            id="ownership-collapseOne"
                                            title={t("RegistrationDetails")}
                                        >
                                            <div className="types">
                                                <PropertyDetailBlock
                                                    label={t(
                                                        "Registration Type"
                                                    )}
                                                    value={t(
                                                        "Register For Someone Else (Principal)"
                                                    )}
                                                />
                                            </div>
                                        </AccordionItem>
                                        <AccordionItem
                                            id="ownership-collapseTwo"
                                            title={t("PrincipalDetails")}
                                        >
                                            <div className="types">
                                                <PropertyDetailBlock
                                                    label={t(
                                                        "PrincipalsFirstName"
                                                    )}
                                                    value={
                                                        stepOneData?.firstName
                                                    }
                                                />
                                                <PropertyDetailBlock
                                                    label={t(
                                                        "PrincipalsLastName"
                                                    )}
                                                    value={
                                                        stepOneData?.lastName
                                                    }
                                                />
                                                <PropertyDetailBlock
                                                    label={t(
                                                        "PrincipalsIdType"
                                                    )}
                                                    value={t(
                                                        getLabel(
                                                            ID_TYPE,
                                                            stepOneData?.id_type,
                                                            lang
                                                        )
                                                    )}
                                                />
                                                <PropertyDetailBlock
                                                    label={t(
                                                        "PrincipalsIdNumber"
                                                    )}
                                                    value={
                                                        stepOneData?.id_number
                                                    }
                                                />
                                                <PropertyDetailBlock
                                                    label={t("PoaExpiryDate")}
                                                    value={
                                                        stepOneData?.poa_expiry_date
                                                    }
                                                />
                                                <PropertyDetailBlock
                                                    label={t("PrincipalsPhone")}
                                                    value={stepOneData?.phone}
                                                />
                                                <PropertyDetailBlock
                                                    label={t("PrincipalsEmail")}
                                                    value={stepOneData?.email}
                                                />
                                            </div>
                                        </AccordionItem>
                                        <AccordionItem
                                            id="ownership-collapseThree"
                                            title={t("PrincipalDocuments")}
                                        >
                                            <ul className="inner-list">
                                                {/* <li>
                                                    <div className="icon">
                                                        <img src="/img/doc-icon.svg" alt="Document Icon" />
                                                    </div>
                                                    <h6>
                                                        <span>Title Deed</span>
                                                        <a href="https://adresstorageaccount.blob.core.windows.net/adrescontainer/deed/1768452271.0534701_istockphoto-517188688-1024x1024_-_Copy.jpg" target="_blank">1768452271.0534701_istockphoto-517188688-1024x1024_-_Copy.jpg</a>
                                                    </h6>
                                                    <button className="btn btn-white btn-sm view-btn">View<img className="ml4" src="/img/eye.svg" alt="view Icon" /></button>
                                                </li>

                                                <li>
                                                    <div className="icon">
                                                        <img src="/img/image-iconB.svg" alt="Document Icon" />
                                                    </div>
                                                    <h6>
                                                        <span>Floor Plans</span><a href="https://adresstorageaccount.blob.core.windows.net/adrescontainer/floor_plans/1768452274.4366083_istockphoto-893423832-1024x1024_-_Copy_-_Copy.jpg" target="_blank">1768452274.4366083_istockphoto-893423832-1024x1024_-_Copy_-_Copy.jpg</a>
                                                    </h6>
                                                    <button className="btn btn-white btn-sm view-btn">View<img className="ml4" src="/img/eye.svg" alt="view Icon" /></button>
                                                </li> */}

                                                <FileUploadItem
                                                    iconSrc="/img/documents-icon.svg"
                                                    title={t(
                                                        "PrincipalsIdDocument"
                                                    )}
                                                    required={true}
                                                    subtitle={
                                                        !principalIdDoc &&
                                                        t("1 Image Required")
                                                    }
                                                    bucketName="bidder_document"
                                                    section="documents"
                                                    property="principalIdDoc"
                                                    documents={principalIdDoc}
                                                    docType="16"
                                                    imageOnly={true}
                                                    allowMultiple={false}
                                                    isSellerPropertyDetail
                                                />

                                                <FileUploadItem
                                                    iconSrc="/img/documents-icon.svg"
                                                    title={t(
                                                        "PowerOfAttorneyDocument"
                                                    )}
                                                    required={true}
                                                    subtitle={
                                                        !powerOfAttorneyDoc &&
                                                        t("1 Image Required")
                                                    }
                                                    bucketName="bidder_document"
                                                    section="documents"
                                                    property="powerOfAttorneyDoc"
                                                    documents={
                                                        powerOfAttorneyDoc
                                                    }
                                                    docType="16"
                                                    imageOnly={true}
                                                    allowMultiple={false}
                                                    isSellerPropertyDetail
                                                />
                                            </ul>
                                        </AccordionItem>
                                    </div>
                                </div>

                                <div className="bidder-btns mb-4">
                                    <button
                                        onClick={() => {
                                            setBuyerField(
                                                "step",
                                                BUYER_REGISTRATION_STEPS.PRINCIPAL_DOCS
                                            );
                                        }}
                                        className="btn btn-sky back-btn"
                                    >
                                        <img
                                            src="/img/arrow-left.svg"
                                            className="mr4"
                                            alt=""
                                            style={{
                                                transform:
                                                    lang === "ar"
                                                        ? "rotate(180deg)"
                                                        : "none",
                                            }}
                                        />
                                        {t("Back")}
                                    </button>
                                    <button
                                        onClick={() =>
                                            setBuyerField(
                                                "isBidderRegistrationModalOpen",
                                                true
                                            )
                                        }
                                        className="btn btn-primary"
                                    >
                                        {t("SignAndSubmit")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {isBidderRegistrationModalOpen && (
                <BidderRegistrationAgreementModal
                    show={isBidderRegistrationModalOpen}
                    onClose={() =>
                        setBuyerField("isBidderRegistrationModalOpen", false)
                    }
                    proceedToPaymentStep={() => {
                        setBuyerField("step", BUYER_REGISTRATION_STEPS.PAYMENT);
                        setBuyerField("isBidderRegistrationModalOpen", false);
                    }}
                />
            )}
        </div>
    );
};

const AccordionItem = ({ id, title, children }) => (
    <div className="accordion-item">
        <h2 className="accordion-header">
            <button
                className="accordion-button fw-semibold"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#${id}`}
            >
                {title}
            </button>
        </h2>

        <div
            id={id}
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionFlushExample"
        >
            <div className="accordion-body">{children}</div>
        </div>
    </div>
);

const PropertyDetailBlock = ({
    label,
    value,
    isFullBlock = false,
    isList = false,
}) => {
    const { t } = useTranslationHook();
    return (
        <div className={`block ${isFullBlock ? "full-block" : ""}`}>
            <h6>
                <span>{label}</span>{" "}
                {!isList
                    ? (
                          <span
                              style={{ all: "unset" }}
                              dangerouslySetInnerHTML={{ __html: value }}
                          />
                      ) || t("Not Applicable")
                    : ""}
            </h6>

            {isList && value?.length && (
                <ul className="amenities">
                    {value?.map((value) => (
                        <li key={value?.value}>{t(value?.label)}</li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const getLabel = (list, value, lang) => {
    let temp = list?.find((item) => String(item.value) === String(value));
    return (
        (!temp
            ? ""
            : !lang
              ? temp.label
              : lang === "en"
                ? temp.label
                : temp.label_ar) || "Not Applicable"
    );
};

export default DetailsReview;
